import { render, staticRenderFns } from "./CopyBtnHighlighter.vue?vue&type=template&id=c6a645b4&"
import script from "./CopyBtnHighlighter.vue?vue&type=script&lang=ts&"
export * from "./CopyBtnHighlighter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6a645b4')) {
      api.createRecord('c6a645b4', component.options)
    } else {
      api.reload('c6a645b4', component.options)
    }
    module.hot.accept("./CopyBtnHighlighter.vue?vue&type=template&id=c6a645b4&", function () {
      api.rerender('c6a645b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/CopyBtnHighlighter.vue"
export default component.exports